export class StylePaymentColor {

    color: any;

    constructor() {}

    setColor(type: string, color: string){
        
        if(type === 'backgroundcolor'){
            return this.color = {
                'background-color' : color
              }
        } else {
            return this.color = {
                '10111-color' : color
              }
        }
    }

    getColor() {
        return this.color;
    }
}